<template>
  <div class="table">
    <div class="container">
      <el-row>
        <el-button size="mini" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
      </el-row>
      <div class="handle-box">
        <el-form :model="headData" :label-position="labelPosition" ref="headDataForm" label-width="140px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('apply.no')">
                <!--单据编号-->
                <el-input class="handle-input" v-model="headData.applyNo" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('apply.subject')">
                <!--主题-->
                <el-input class="handle-input" v-model="headData.subject" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="入围供应商">
                <el-input class="handle-input" v-model="supplierNames" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('apply.quotationType')">
                <!--报价类型-->
                <ic-select disabled="true" table="TT_QUOTATION_APPLY" class="handle-input" field="QUOTATION_TYPE" v-model="headData.quotationType"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="历史报价" name="line">
          <!--历史报价-->
          <div v-for="(round,i) in roundList" :key="i">
            <el-row :gutter="16">
              <!--轮次-->
              <el-col :span="2">{{$t('apply.round')}}：</el-col>
              <el-col :span="1">{{round.roundNumber}}</el-col>
              <!--报价提交日期-->
              <el-col :span="3">{{$t('apply.quoteSubmitDate')}}：</el-col>
              <el-col :span="3">
                <el-link> {{round.submitDate}} </el-link>
              </el-col>
              <!--轮次说明-->
              <el-col :span="2">{{$t('apply.roundRemark')}}：</el-col>
              <el-col :span="4">{{round.remark}}</el-col>
              <!--轮次附件-->
              <el-col :span="2">
                <el-link type="primary" @click="showAttachmentDialogM($t('apply.roundAttachment'),round.ttQuotationApplyRoundId,'QUOTATION_APPLY_ROUND')">{{$t('apply.roundAttachment')}}</el-link>
              </el-col>
              <!--报价附件-->
              <el-col :span="3">
                <el-link type="primary" @click="showQuotationAttachmentDialogM(round.ttQuotationId,round.supplierList)">{{$t('apply.quoteAttachment')}}</el-link>
              </el-col>
            </el-row>
            <el-table :data="round.quotationProductList" ref="quotationLineTableDataRef" :row-class-name="tableRowClassName" border class="table">
              <el-table-column show-overflow-tooltip prop="supplierName" fixed label="供应商" min-width="200px"></el-table-column>
              <el-table-column show-overflow-tooltip prop="eightBitCode" width="80" label="8位码"></el-table-column>
              <el-table-column show-overflow-tooltip prop="eightBitCodeName" label="8位码名称" min-width="120px"></el-table-column>
              <!--发货市-->
              <el-table-column show-overflow-tooltip prop="pickupPoint" :label="$t('apply.shippingCity')" min-width="120px"></el-table-column>
              <!--到货仓库-->
              <el-table-column show-overflow-tooltip prop="dcName" :label="$t('apply.arrivalAarehouse')" min-width="250"></el-table-column>
              <!--温区-->
              <el-table-column show-overflow-tooltip prop="temperatureI18n" :label="$t('apply.temperature')" min-width="120px"></el-table-column>
              <el-table-column show-overflow-tooltip prop="lineUnit" label="结算单位" min-width="120px"></el-table-column>
              <!--运输方式-->
              <el-table-column show-overflow-tooltip prop="transportaionMethod" :label="$t('apply.transportaionMethod')" min-width="120px"></el-table-column>
              <!--有效开始日期-->
              <el-table-column show-overflow-tooltip prop="effectiveBeginDate" :label="$t('apply.effectiveBeginDate')" min-width="120px">
                <template slot-scope="scope">
                  {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="linePrice" label="线路价格" min-width="130px"></el-table-column>
              <el-table-column show-overflow-tooltip prop="isSpecialFreight" width="100" label="非标准线路运费" :formatter="formatisSpecial"></el-table-column>
              <el-table-column show-overflow-tooltip prop="productPrice" width="150" label="产品运费（不含税）"></el-table-column>
              <!--币种-->
              <el-table-column show-overflow-tooltip prop="currencyCode" :label="$t('apply.currency')" min-width="120px"></el-table-column>
              <el-table-column show-overflow-tooltip prop="leadTime" label="Leadtime" min-width="120px"></el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="externalPackagingLength" label="外包装长(cm)" min-width="120px"></el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="externalPackagingWidth" label="外包装宽(cm)" min-width="120px"></el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="externalPackagingHeight" label="外包装高(cm)" min-width="120px"></el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="externalPackagingNetweight" label="外包装净重(kg)" min-width="130px"></el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="externalPackagingGrossweight" label="外包装毛重(kg)" min-width="130px"></el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="palletLayerNumber" label="每Pallet层数" min-width="120px"></el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="palletLayerBoxNumber" label="每层箱数" min-width="100px"></el-table-column>
              <!--备注-->
              <el-table-column show-overflow-tooltip prop="remarks" :label="$t('common.remarks')" min-width="120px"></el-table-column>
              <!--定点审批状态-->
              <el-table-column show-overflow-tooltip prop="sourcingProductStatus" :label="$t('apply.sourcingApprovalStatus')" min-width="150px"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>

    </div>

    <el-dialog :title="title" :visible.sync="showAttachmentDialog" append-to-body width="60%">
      <el-table :data="attachmentList" border highlight-current-row class="table">
        <el-table-column sortable prop="documentName" label="文件" min-width="130px">
          <template slot-scope="scope">
            <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
          </template>
        </el-table-column>
        <el-table-column sortable prop="userName" label="创建人" min-width="130px"></el-table-column>
        <el-table-column sortable prop="createDate" label="创建时间" min-width="130px">
          <template slot-scope="scope">
            {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="$t('apply.quoteAttachment')" :visible.sync="showQuotationAttachmentDialog" append-to-body width="60%">
      <el-row align="middle" :gutter="10" v-for="(supplier,ix) in supplierList" :key="ix">
        <el-col :span="4">
          {{supplier.supplierName}}
        </el-col>
        <el-col :span="20">
          <el-table :data="fileList[ix]" border highlight-current-row class="table">
            <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
              <template slot-scope="scope">
                <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
              <template slot-scope="scope">
                {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { quotationHistoryInit } from "@/api/quoteByProductSup.js";
import { fileService } from "@/api/common/file-utils";
import IcSelect from "@/components/common/icSelect";
export default {
  name: 'quotation-history',
  components: { IcSelect },
  data() {
    return {
      ttQuotationApplyId: null,
      labelPosition: 'right',
      headData: {},
      quotationLineTableData: [],
      applyTypeList: [],
      quotationTypeList: [],
      fileList: [],
      activeName: 'line',
      roundList: [],
      supplierList: [],

      showAttachmentDialog: false,
      showQuotationAttachmentDialog: false,
      attachmentList: [],
      title: '',
      tmSupplierId: null,
      supplierNames: '',
    }
  },
  created() {
    this.quotationHistoryPageInitM(this.$route.query.applyId);
    this.ttQuotationApplyId = this.$route.query.applyId;
  },
  methods: {
    quotationHistoryPageInitM(applyId) {
      let _this = this;
      quotationHistoryInit(applyId).then((res) => {
        _this.supplierNames = res.supplierNames;
        _this.headData = res.quotationApply;
        _this.roundList = res.roundHistory;
        _this.tmSupplierId = res.tmSupplierId;
      });
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //文件列表数据获取
    showAttachmentDialogM: function (title, recId, reckindId, seq) {
      this.showAttachmentDialog = true;
      this.title = title;
      let attachment = {};
      if (!!seq) {
        attachment.seq = seq + '';
      }
      attachment.tsRecId = recId;
      attachment.tsReckindId = reckindId;
      fileService.getFileList(attachment).then((fileRes) => {
        this.attachmentList = fileRes;
      })
    },
    showQuotationAttachmentDialogM: function (quotationId, supList) {
      let _this = this;
      _this.showQuotationAttachmentDialog = true;
      _this.supplierList = supList;
      //获取附件信息
      _this.showFileList = [];
      if (!!supList) {
        console.log(supList);
        supList.forEach((sup, inx) => {
          _this.showFileList.push([]);
          let attachment = {};
          attachment.tsRecId = quotationId;
          attachment.tsReckindId = 'QUOTATION';
          attachment.seq = sup.tmSupplierId + '';
          fileService.getFileList(attachment).then((fileRes) => {
            //this.showFileList.push(fileRes);
            _this.$set(_this.fileList, inx, fileRes);
          })
        })
      }
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    formatisSpecial: function (row, column) {
      return row.isSpecialFreight == "Y" ? "是" : "否"
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.colour === 'Y') {
        return 'success-row-q';
      } else {
        return '';
      }
    }
  }
}
</script>
<style scoped>
.handle-box {
  margin-top: 10px;
}
.handle-input {
  width: 85%;
}

.handle-input-out {
  width: 70%;
}
.action-btn {
  margin-bottom: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

.lineClass .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.el-table /deep/.success-row-q {
  background: #ffa796;
}
</style>
